// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.map.to-json.js
// module id = 217
// module chunks = 114276838955818 151237674209022 207229069319885